export default [
  {
    path: 'inquiry',
    name: 'inquiry.create',
    component: () => import('@pages/inquiry/Index'),
    props: true
  },
]
